/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import { createContext } from "react";

export const DeepLinkContext = createContext({
  inviteCode: null as string | null,
});
